import React, { useState, useEffect } from "react";
import axios from "axios";
import { G_API } from "../../constants/globalVar";
import PageSlider from "../PageSlider";
import AllJobs from "../AllJobs";
import { FiArrowRightCircle } from "react-icons/fi";

const JobVacancyPage = () => {
    const [items, setItems] = useState([]);
    useEffect(() => {
        var config = {
            method: "post",
            maxBodyLength: Infinity,
            url: G_API + "job-vacancies/JOB_VACANCY_LIST",
        };

        axios(config)
        .then((response) => {
            const items = response.data.DATAS;
            setItems(items);
        })
        .catch(function (error) {
            console.error(error);
        });
    }, []);
    return (
        <>
            <div
                id="header-carousel"
                className="carousel slide"
                data-bs-ride="carousel"
            >
                <div className="carousel-inner">
                <PageSlider inputType="Job Vacancy" />
                </div>
            </div>
            <section
                id="short-description"
                style={{
                backgroundColor: "#fcfcfc",
                }}
            >
                <div className="container-xxl py-5">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                                <div className="h-100">
                                    <h2 className="display-6 mb-5">
                                        Ah Nyar Institute: Empowering Education for All
                                    </h2>
                                    <p className="mb-5">
                                        Ah Nyar Institute (in Burmese အညာအင်စတီကျု) is an independent, non-profit, and value-based academic institution striving for educational justice in Myanmar. The institute was founded on 2 August 2022 and is envisioned to be “a leading civic institution in Ah Nyar Region that strives to improve the capacity of young people from under-served communities to become future leaders”. The initial establishments were led by a group of individuals and later joined by several scholars and young individuals. Since our establishment, we have planned to establish the institute as an independent and value-based academic institution. Ah Nyar Institute holds an independent status from all factors - ethnicity, religion, and political ideology – and the entire spectrum of our institution is guided by the core values that are enshrined in our founding documents. We will serve as a catalyst for the intellectual development of the Ah Nyar community.
                                    </p>
                                    <a className="btn btn-primary py-2 px-3 me-3" href="#job">
                                        <span className="">Explore Jobs</span>
                                        <FiArrowRightCircle size="20px" className="ms-1" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div
                                className="position-relative overflow-hidden h-100"
                                style={{ minHeight: "400px" }}
                                >
                                <img
                                    className="position-absolute w-100 h-100 mt-5 mb-5"
                                    src="/assets/job-cover.jpg"
                                    alt=""
                                    style={{
                                    objectFit: "cover",
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {(items && items.length > 0) && (
                <section id="job">
                    <div className="container-xxl my-5 py-5">
                        <div className="container py-5">
                            <div className="row g-4 justify-content-center text-center list">
                                <h3 className="mb-1">
                                    Discover Your Next Career Opportunity with Us
                                </h3>
                                <p className="mb-5">
                                    Explore new career horizons with us! Uncover exciting job
                                    opportunities that could shape your future.
                                </p>
                                <div className="row d-flex flex-wrap">
                                    {items.map((item) =>
                                        item.status ? (
                                            <AllJobs
                                            key={item.id}
                                            item={item}
                                            />
                                        ) : null
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};
export default JobVacancyPage;
